import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OpportunityService from '../../../Services/opportunityService';
import OpportunityStatusChangeItem from '../../../Domain/OpportunityStatusChangeItem';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

// Drives the GeneralEditWizzardBaseFigma status-change action panel for an opportunity.
// Not entity CRUD, so entityName is omitted and the plain 'Opportunity Status Change' title
// wins. Reason Lost shows only for status 12 (Lost); Comment hides for status 3 and is
// required for statuses 5/7/8/9/10/98. The old-close-date confirm is wired at the call site
// via the wizard approveBeforeSaveCheck / approveBeforeSaveMessage props.
export default class OpportunityStatusChangeWindowDescription {
  static titleForCreate = 'Opportunity Status Change';
  static titleForEdit = 'Opportunity Status Change';
  static finishButtonLabel = 'Save';
  static itemType = OpportunityStatusChangeItem;
  static messageOnSuccess = 'Opportunity status has been changed!';

  static serviceFunction = (edited) => {
    const payload = {
      OpportunityWorkflowAction: edited.Status,
      Comment: edited.Comment,
      OpportunityId: edited.OpportunityId,
      ReasonLostCode: edited.ReasonLostCode,
    };
    return OpportunityService.PostOpportunity(payload);
  };

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Status',
          label: 'Status',
          className: 'col-12',
          type: InputTypesEnum.OpportunityStatusChange,
          validityChecker: ValidityHelper.forRequiredTextField,
          EntityId: 'OpportunityId',
        },
        {
          fieldName: 'ReasonLostCode',
          label: 'Reason Lost',
          className: 'col-12',
          type: InputTypesEnum.OpportunityReasonLost,
          validityChecker: ValidityHelper.forRequiredTextField,
          EntityId: 'OpportunityId',
          hide: (item) => parseInt(item.Status) !== 12,
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: (value, item) => OpportunityStatusChangeWindowDescription.commentValidation(item.Status, value),
          hide: (item) => parseInt(item.Status) === 3,
        },
      ],
    },
  ];

  static commentValidation(status, value) {
    const statusesRequiringComment = [5, 7, 8, 9, 10, 98];
    if (statusesRequiringComment.includes(parseInt(status))) return ValidityHelper.forRequiredTextField(value);
    return '';
  }

  // True when the user is marking the Opportunity as Won (status 11) and its Actual Close Date
  // is missing or more than 30 days in the past.
  static shouldConfirmOldActualCloseDate(item) {
    if (item.Status !== '11') {
      return false;
    }

    if (!item.ActualCloseOn) {
      return true;
    }

    return dateTimeHelper.dateDiffInDays(new Date(item.ActualCloseOn), new Date()) > 30;
  }

  static buildOldActualCloseDateWarning(actualCloseOn) {
    return `Warning: The Actual Close Date is more than 30 days in the past or is an empty value: ${dateTimeHelper.toYYYYsMMsDD(
      actualCloseOn
    )}. Do you want to proceed with marking this Opportunity as Won?`;
  }
}
